<template>
    <div
        class="sub-account-post-row h-[62px] flex flex-col justify-between py-0.5 px-1.5"
        :class="{selected, highlighted}"
        @click="togglePost"
    >
        <div class="top-row flex items-baseline gap-1">
            <div class="text-sm">{{ formatDate(post.date, 'dd.MM.yy') }}</div>
            <div class="grow"/>
            <transaction-link
                v-if="post.transactionUuid"
                :transaction-uuid="post.transactionUuid"
                title="Vis bilag"
                class="text-sm text-primary"
            >
                {{ post.transactionNo }}
            </transaction-link>
            /
            <invoice-link
                v-if="post.invoiceUuid"
                :invoice-uuid="post.invoiceUuid || 'null'"
                :sub-account-uuid="post.subAccountUuid"
                title="Vis detaljer"
                class="text-sm text-primary"
            >
                {{ post.invoiceNo }}
            </invoice-link>
        </div>
        <div class="bottom-row flex">
            <div v-if="hasDiffRemaining">
                <div class="legend">
                    Opprinnelig beløp
                </div>
                <div>
                    {{ formatCurrency(post.amount) }}
                </div>
            </div>
            <div class="grow"/>
            <div>
                <div v-if="hasDiffRemaining" class="legend">
                    Gjenstående beløp
                </div>
                <div>
                    {{ formatCurrency(post.remainingAmount) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import {formatDate} from 'date-fns'
import {formatCurrency} from '@/services/formatter.service'
import TransactionLink from '@/transaction/TransactionLink.vue'
import InvoiceLink from '@/invoice/InvoiceLink.vue'
import {SubAccountLine} from '@/subaccount/outstandingBalance/SubAccountLine'
import {computed} from 'vue'

type SubAccountLineWithTransactionUuid = SubAccountLine & {
    transactionUuid: string
}

const props = defineProps({
    selected: {
        type: Boolean,
        default: false
    },
    highlighted: {
        type: Boolean,
        default: false
    },
    post: {
        type: Object as () => SubAccountLineWithTransactionUuid,
        required: true
    }
})

const emit = defineEmits(['togglePost'])

const togglePost = () => {
    emit('togglePost', props.post)
}

const hasDiffRemaining = computed(() => {
    return props.post.remainingAmount !== props.post.amount
})
</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.sub-account-post-row {
    &.selected {
        @apply bg-primary/50 ring-1;
    }

    &.highlighted {
        @apply ring-1 ring-inset ring-primary;
    }
    .legend {
        @apply text-xs;
    }
}

</style>